import React from 'react';
import cn from '@/utils/cn';
import { Finding } from './contentAudit.types';
import SPAFindingNote from './SPAFindingNote';

interface Props {
  findings: Finding[];
  showSection?: boolean;
}

// Hairline separators make each ledger row's boundary explicit — at full pane width adjacent
// findings otherwise blur together.
const FindingList = ({ findings, showSection = false }: Props) => (
  <div className="tw-flex tw-flex-col">
    {findings.map((finding, index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={cn(
          'tw-py-5 first:tw-pt-0 last:tw-pb-0',
          index > 0 && 'tw-border-0 tw-border-t tw-border-solid tw-border-spa-border-secondary',
        )}
      >
        <SPAFindingNote finding={finding} showSection={showSection} />
      </div>
    ))}
  </div>
);

export default FindingList;
